(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.result = {
    attach: function (context, settings) {
      $('.js-toggle-search', context).click(function () {
        $('.js-toggle-search', context).parent().removeClass('active');
        $(this).parent().addClass('active');
        $('.holiday-results').removeClass('active');
        $('.js-results-' + $(this).data('type'), context).addClass('active');
      });

      $('.results__content').once('search-tabs').each(function () {
        var checkExist = setInterval(function () {
          if ($('.holiday-results--current').length) {
            $('.search-toggle__loading').remove();
            var searchResultsCurrent = $('.holiday-results--current article');
            if (searchResultsCurrent.length) {
              $('.search-toggle__container--current').append('<p class="search-toggle__text">' + searchResultsCurrent.data('duration') + ' nights from ' + searchResultsCurrent.data('arrival') + '</p>');
              $('.search-toggle__container--current').append('<p class="search-toggle__price">From £' + searchResultsCurrent.parent().data('lowest') + '</p>');
            } else {
              $('.search-toggle__container--current').off('click');
              $('.search-toggle__container--current').append('<p class="search-toggle__text">Sorry, but there are no holidays for your search criteria.</p>');
            }

            var searchResultsPrev = $('.holiday-results--prev article');
            if (searchResultsPrev.length) {
              $('.search-toggle__container--prev').append('<p class="search-toggle__text">' + searchResultsPrev.data('duration') + ' nights from ' + searchResultsPrev.data('arrival') + '</p>');
              $('.search-toggle__container--prev').append('<p class="search-toggle__price">From £' + searchResultsPrev.parent().data('lowest') + '</p>');
            } else {
              $('.search-toggle__container--prev').off('click');
              $('.search-toggle__container--prev').append('<p class="search-toggle__text">Sorry, but there are no holidays for your search criteria.</p>');
            }

            var searchResultsnext = $('.holiday-results--next article');
            if (searchResultsnext.length) {
              $('.search-toggle__container--next').append('<p class="search-toggle__text">' + searchResultsnext.data('duration') + ' nights from ' + searchResultsnext.data('arrival') + '</p>');
              $('.search-toggle__container--next').append('<p class="search-toggle__price">From £' + searchResultsnext.parent().data('lowest') + '</p>');
            } else {
              $('.search-toggle__container--next').off('click');
              $('.search-toggle__container--next').append('<p class="search-toggle__text">Sorry, but there are no holidays for your search criteria.</p>');
            }

            clearInterval(checkExist);
          }
        }, 100);
      });

      const $drawerToggle = $('.js-toggle-drawer', context);
      $drawerToggle.once().click(function () {
        const $this = $(this);
        if ($this.hasClass('is-active')) {
          $this.removeClass('is-active');
          $this.closest('.accommodation').find('.js-drawer').removeClass('is-active');
          $this.closest('.accommodation').find('.accommodation__summary').show();
          $this.text('View more features');
          return;
        }
        $this.addClass('is-active');
        $this.closest('.accommodation').find('.js-drawer').addClass('is-active');
        $this.closest('.accommodation').find('.accommodation__summary').hide();
        $this.text('Hide more features');
      });
    }
  };

  Drupal.behaviors.slider = {
    attach: function (context, settings) {
      const $sliders = $('.js-slider-gallery', context);
      const $galleries = $('.js-light-gallery', context);

      $sliders.once('light_slider').each(function () {
        const $slider = $(this);
        if ($(this).children().length > 1) {
          const $s = $slider.lightSlider({
            onBeforeStart: function ($el) {
              for (var i = 1; i <= 2; i++) {
                var $img = $el.find('div:nth-child(' + i + ') img').first();
                $img.css('display', 'initial');
                $img.lazyload(); // eslint-disable-line
                // $img.css('min-height', '200px');
              }
            },
            onSliderLoad: function ($el) {
              $('.lSPrev').hide();
            },
            onAfterSlide: function ($el, scene) {
              for (var i = 0; i <= $el.find('img').length; i++) {
                var $img = $el.find('img').eq($el.getCurrentSlideCount() + i);
                $img.attr('src', $img.attr('data-src'));
                $img.css('display', 'initial');
              }

              var lsPrev = $el.parent().find('.lSPrev');
              var lsNext = $el.parent().find('.lSNext');

              if ($el.getCurrentSlideCount() === 1) {
                lsPrev.hide();
              } else {
                lsPrev.show();
                lsNext.show();
              }
            },
            item: 1,
            loop: false,
            slideMargin: 0,
            adaptiveHeight: false
          });

          $s.refresh();
          $('.js-toggle-search').click(function () {
            $s.refresh();
          });
        } else {
          $(this).find('.lazyload').lazyload();
        }
      });
      $galleries.lightGallery();
    }
  };
})(window.Drupal, window.jQuery);
